import { render, staticRenderFns } from "./helpLianxiang.vue?vue&type=template&id=9caefcbc&scoped=true&"
import script from "./helpLianxiang.vue?vue&type=script&lang=js&"
export * from "./helpLianxiang.vue?vue&type=script&lang=js&"
import style0 from "./helpLianxiang.vue?vue&type=style&index=0&id=9caefcbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caefcbc",
  null
  
)

export default component.exports